import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PricingService } from 'app/core/pricing/pricing.service';
import { InitialData } from './pricing-quantity.types';

@Injectable({
    providedIn: 'root'
})
export class PricingQuantityDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _pricingService: PricingService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<InitialData> {
        return this._pricingService.getQuantities(route.params['id'])
        .pipe(
            map((quantities) => ({
                quantities
            })
            ),
            catchError(err => {
                console.log(err);
                
                this._pricingService.errorMessage = err.error.message ? err.error.message : "Something went wrong !";
                return of(new DefaultResponse().quantities);
            })
        );
        
    }

}
class DefaultResponse implements InitialData {
    quantities: any = [];
}